import { useFormContext, useWatch } from "react-hook-form";
import { useMemo } from "react";

// Helper: Evaluate if all conditions are satisfied
const evaluateConditions = (formValues, conditions, operator = "AND",) => {
    if (!conditions || !conditions.length) return true;

    const results = conditions.map(({ keyName, value }) => {
        return formValues?.[keyName] === value;
    });

    if (operator === "AND") return results.every(Boolean);
    if (operator === "OR") return results.some(Boolean);
    return false;
};

// Main Hook
export const useConditionalVisibility = (dependantConditions = {conditions: [], operator: "AND"}, isLogDisplay) => {
    

    const { control } = useFormContext();

    // Watch all fields involved in the condition
    const watchedValues = useWatch({
        control,
        name: dependantConditions.conditions.map((cond) => cond.keyName),
    });
  isLogDisplay && console.log("watchedValues", watchedValues);

    // Combine watched values into a keyed object
    const formValues = useMemo(() => {
        const result = {};
        dependantConditions.conditions.forEach((cond, i) => {
            result[cond.keyName] = watchedValues[i];
        });
        return result;
    }, [watchedValues, dependantConditions]);


    // Compute final result
    return evaluateConditions(formValues, dependantConditions.conditions, dependantConditions.operator, isLogDisplay);
};


